import { render, staticRenderFns } from "./autosize-input.vue?vue&type=template&id=5a49eb5f&scoped=true&"
import script from "./autosize-input.vue?vue&type=script&lang=js&"
export * from "./autosize-input.vue?vue&type=script&lang=js&"
import style0 from "./autosize-input.vue?vue&type=style&index=0&id=5a49eb5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49eb5f",
  null
  
)

export default component.exports